export type State = "search" | "start";

export type BoardModeData = {
    mode: "board" | "project";
    boardUID: string;
    onlyRead: boolean;
    host: string;
    token: string;
    accessSelector: (data: any) => void; //accessMenu.open
    HTTPRequest: () => void; //MakeRequest
    notificator: (text: string) => void;
    searchInputState: (value: number) => void;
    stateChange: () => void;
    projectId?: number;
};

export type PasswordGetResponse = {
    password: string;
};

export type AccountInfoResponse = {
    id: string;
    name: string;
    email: string;
};

export type BoardAccessResponse = {
    access: "owner" | "edit" | "view";
};
export type Member = {
    name: string;
    email: string;
    access: "owner" | "edit" | "view" | "view_copy";
    accountId: number;
    memberId: number;
};

export type BoardShareResponse = {
    accessByTeam: "owner" | "edit" | "view";
    accessByLink: "owner" | "edit" | "view";
    teamId: number;
    access: "owner" | "edit" | "view";
    teamName: string;
    inviteLink: string;
    allowControlByLink: "allow" | "deny";
    members: Member[];
};

export type ProjectShareResponse = {
    members: Member[];
    projectName: string;
    teamId: number;
};

export type MemberMap = {
    memberId: number;
    name: string;
    email: string;
    access: "" | "owner" | "edit" | "view" | "view_copy";
};
export type MapMembers = Map<number, MemberMap>;

export type MyAccess = "owner" | "edit" | "view";
export type AccessByLinkOrTeam = "owner" | "edit" | "view" | "denied" | "view_copy";

export type AdditionalDataBoardMode = {
    teamName: string;
    searchAccess: AccessByLinkOrTeam;
    accessByTeam: AccessByLinkOrTeam;
    teamId: number;
    allowControlByLink: "allow" | "deny";
    accessByLink: AccessByLinkOrTeam;
    myAccess?: MyAccess;
};

export type AdditionalDataProjectMode = {
    myAccountId: number;
    searchAccess: "edit";
    projectName: string;
    teamId: number;
    myAccess?: MyAccess;
};

export type AdditionalData = AdditionalDataBoardMode | AdditionalDataProjectMode;

export enum ReasonAccess {
    teamAccess = "teamAccess",
    publicAccess = "publicAccess",
    memberAccess = "memberAccess",
    searchAccess = "searchAccess",
}
